export const EXISTING_HUB_EVENTS = [
  'MatchFound',
  'OpponentLeft',
  'ReceiveGameRoomID',
  'ReceiveFriendMatchInvite',
  'ReceiveMatchID',
  'ReceiveInviteID',
  'CancelFriendMatch',
  'FriendMatchRejected',
  'ReceiveTrade',
  'OpponentLeftGame',
  'OpponentSceneReady',
  'SyncGameStart',
] as const;

export const PRESENCE_HUB_EVENTS = [
  'FriendStatusChanged',
  'FriendsOnlineSnapshot',
] as const;

export type FriendStatus = 0 | 1 | 2;

export interface MatchFoundPayload {
  matchID: number;
  opponentID: number;
  createRoom: boolean;
  botType?: number;
}

export interface OpponentLeftPayload {
  matchID: number;
}

export interface ReceiveGameRoomIDPayload {
  gameRoomID: string;
}

export interface FriendMatchInvitePayload {
  gameRoomType: number;
  fromUserId: number;
  inviteID: number;
}

export interface ReceiveMatchIDPayload {
  matchID: number;
}

export interface ReceiveInviteIDPayload {
  inviteID: number;
}

export interface FriendStatusChangedPayload {
  userId: number;
  status: FriendStatus;
}

export interface FriendsOnlineSnapshotPayload {
  onlineUserIds: number[];
}

/** 相容後端 PascalCase 與 SignalR camelCase 欄位 */
function pick<T>(data: Record<string, unknown>, ...keys: string[]): T | undefined {
  for (const key of keys) {
    const value = data[key];
    if (value !== undefined && value !== null) return value as T;
  }
  return undefined;
}

export function normalizeMatchFoundPayload(data: unknown): MatchFoundPayload {
  const raw = (data ?? {}) as Record<string, unknown>;
  return {
    matchID: pick<number>(raw, 'matchID', 'MatchID')!,
    opponentID: pick<number>(raw, 'opponentID', 'OpponentID')!,
    createRoom: pick<boolean>(raw, 'createRoom', 'CreateRoom') ?? false,
    botType: pick<number>(raw, 'botType', 'BotType'),
  };
}

export function normalizeOpponentLeftPayload(data: unknown): OpponentLeftPayload {
  const raw = (data ?? {}) as Record<string, unknown>;
  return { matchID: pick<number>(raw, 'matchID', 'MatchID')! };
}

export function normalizeReceiveMatchIDPayload(data: unknown): ReceiveMatchIDPayload {
  const raw = (data ?? {}) as Record<string, unknown>;
  return { matchID: pick<number>(raw, 'matchID', 'MatchID')! };
}

export function normalizeReceiveGameRoomIDPayload(data: unknown): ReceiveGameRoomIDPayload {
  const raw = (data ?? {}) as Record<string, unknown>;
  return { gameRoomID: String(pick(raw, 'gameRoomID', 'GameRoomID', 'gameRoomId') ?? '') };
}

export function normalizeFriendStatusChangedPayload(data: unknown): FriendStatusChangedPayload {
  const raw = (data ?? {}) as Record<string, unknown>;
  return {
    userId: Number(pick<number>(raw, 'userId', 'UserId', 'UserID', 'userID')),
    status: Number(pick<number>(raw, 'status', 'Status')) as FriendStatus,
  };
}

export function normalizeFriendsOnlineSnapshotPayload(data: unknown): FriendsOnlineSnapshotPayload {
  const raw = (data ?? {}) as Record<string, unknown>;
  const ids = pick<number[]>(raw, 'onlineUserIds', 'OnlineUserIds') ?? [];
  return { onlineUserIds: ids.map((id) => Number(id)) };
}
